// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"ad1ea572","599":"2280d3fb"}[chunkId] + ".chunk.css";
};